<span class="pagination" *ngIf="pager && pager.pages?.length">
    <ng-container *ngIf="items?.length === 1; else multipleItemsBlock">
        One item found.<span class="disabled-2">1</span>
    </ng-container>
    <ng-template #multipleItemsBlock>
        {{items.length | number}} items found, displaying
        <ng-container *ngIf="items.length > 50; else displayAllBlock;">
            {{pager.startIndex + 1 }} to {{pager.endIndex + 1}}.[
            <a href="javascript:void(0);"
                [ngClass]="{ 'disabled': pager.currentPage === 1, 'disabled-hyer': disableHyperLink }"
                (click)="setPage(1, $event)">First</a>/<a href="javascript:void(0);"
                [ngClass]="{ 'disabled': pager.currentPage === 1, 'disabled-hyer': disableHyperLink }"
                (click)="setPage(pager.currentPage - 1, $event)">
                Prev
            </a>
            <span class="mar-r2">]</span>
            <ng-container *ngFor="let page of pager.pages;let i=index; let last=last;">
                <a href="javascript:void(0);"
                    [ngClass]="{ 'disabled-2': pager.currentPage === page, 'disabled-hyer': disableHyperLink }"
                    (click)="setPage(page, $event)" [title]="pager.currentPage !== page ? 'Go to page ' + page: null">
                    {{page}}
                </a>
                <span class="mar-r2" *ngIf="!last">,</span>
                <span class="mar-r2" *ngIf="last"></span>
            </ng-container>
            [<a href="javascript:void(0);"
                [ngClass]="{ 'disabled': pager.currentPage === pager.totalPages, 'disabled-hyer': disableHyperLink }"
                (click)="setPage(pager.currentPage + 1, $event)">Next</a>/<a href="javascript:void(0);"
                [ngClass]="{ 'disabled': pager.currentPage === pager.totalPages, 'disabled-hyer': disableHyperLink }"
                (click)="setPage(pager.totalPages, $event)">Last</a>]
        </ng-container>
        <ng-template #displayAllBlock>all items. <span class="disabled-2">1</span></ng-template>
    </ng-template>
</span>